<template>
  <div class="upload-container">
    <div
      class="upload-img"
      v-for="(imgUrl, i) in imageListGroup"
      :key="i"
      :style="uploadImgStyle"
      :src="imgUrl">
        <div class="not-upload">
          <img src="@/assets/img/img-logo.png" alt="" style="margin-bottom: 10px;" />
          <el-upload
            v-if="showUploadBtn"
            class="upload-component"
            :show-file-list="false"
            :with-credentials="true"
            :auto-upload="true"
            :name="name"
            :headers="headers"
            :action="action"
            :fileMaxSize="fileMaxSize"
            :accept="accept"
            :limit="limit"
            :file-list="fileListData"
            :before-upload="beforeUploadFunc"
            :on-change="(file, fileList) => onChangeFunc({ file, fileList, idx: i})"
            :on-success="(response, file, fileList) => onSuccessFunc({ response, file, fileList})"
            :on-error="err => onErrorFunc(err)"
            :on-progress="onProgressFunc"
            :disabled="isLoading || (limit > 1 && maxUploadCount)"
          >
            <el-button class="egl-btn-white" :disabled="isLoading || (limit > 1 && maxUploadCount)">
              {{ $locale("global.upload") }}
            </el-button>
          </el-upload>
          <div class="uploaded" v-if="imageList.length > 0 && imageList[i]">
            <el-image :src="imgUrl" fit="cover">
              <div slot="error" class="image-slot">
                <i class="el-icon-picutre-outline"></i>
              </div>
            </el-image>
            <el-button class="egl-btn-white" @click="deleteAction(i)" size="mini">{{ $locale("global.delete") }}</el-button>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    action: {
      type: String,
      default: "/api/system/uploadFile"
    },
    name: {
      type: String,
      default: "uploadFile"
    },
    imageList: {
      type: Array,
      default: () => [],
    },
    fileMaxSize: {
      type: Number,
      default: 2 * 1024 * 1024
    },
    limit: {
      type: Number,
      default: 1,
    },
    accept: {
      type: String,
      default: ".png, .jpg, .jpeg"
    },
    itemWidth: {
      type: Number,
      default: 230
    },
    itemHeight: {
      type: Number,
      default: 230
    }
  },
  data() {
    return {
      isLoading: false,
      fileListData: [],
    };
  },
  computed: {
    ...mapState("app", {
      token: state => state.token,
    }),
    headers() {
      return {
        "Authorization": this.token,
      };
    },
    maxUploadCount() {
      return this.imageList.length >= this.limit;
    },
    imageListGroup() {
      const _imageList = [ ...this.imageList ];
      if (this.limit === 1) {
        return _imageList;
      } else if (this.limit > 1 && this.imageList.length < this.limit) {
        _imageList.push("");
      }
      return _imageList;
    },
    uploadImgStyle() {
      let _style = "";
      if (this.itemWidth) {
        _style += `width: ${this.itemWidth}px;`;
      }
      if (this.itemHeight) {
        _style += `height: ${this.itemHeight}px;`;
      }
      return _style;
    },
    showUploadBtn() {
      let _result = null;
      if (this.limit === 1) {
        _result = this.imageList.length === 0 || (this.imageList.length === 1 && !this.imageList[0]);
      } else if (this.limit > 1) {
        _result = this.imageList.length < this.limit;
      }
      return _result;
    }
  },
  methods: {
    onChangeFunc(options) {
      this.$emit("onChange", options);
    },
    onSuccessFunc(options) {
      const { success, message } = options.response || {};
      this.fileListData = [];
      if (success) {
        this.isLoading = false;
        this.$emit("onSuccess", options);
      } else {
        this.isLoading = false;
        this.handleErrorFunc(message);
      }
    },
    onErrorFunc(err) {
      const { message, status } = err;
      let _errObj = "";
      if (status === 413) {
        this.uploadFileOverSize();
      }
      if (typeof message === "string") {
        _errObj = message.replace("Error:", "");
        _errObj = JSON.parse(_errObj);
      }

      this.fileListData = [];
      this.handleErrorFunc(_errObj.message);
      this.isLoading = false;
      this.$emit("onError", err);
    },
    onProgressFunc() {
      this.isLoading = true;
    },
    beforeUploadFunc(file) {
      let _result = true;
      if (file.size > this.fileMaxSize) {
        _result =false;
        this.uploadFileOverSize();
        this.fileListData = [];
      }
      return _result;
    },
    handleErrorFunc(err = this.$locale("err.uploadError")) {
      this.$alert(err, { showClose: false });
    },
    deleteAction(idx) {
      this.$emit("onDelete", idx);
    }
  }
};
</script>
<style lang="less" scoped>
  .upload-container {
    display: inline-block;
    .upload-component {
      display: inline-block;
      & +.el-button {
        margin-left: 10px;
      }
    }
    .upload-img {
      display: inline-block;
      position: relative;
      // width: 230px;
      // height: 230px;
      min-width: 60px;
      min-height: 60px;
      margin-right: 20px;
      background: @light-grey-bg;
      overflow: hidden;

      &:last-child {
        margin-right: 0;
      }

      &:before {
        content: "";
        display: block;
        padding-top: 100%;
      }
      .not-upload, .uploaded {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
      .not-upload {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          // margin-bottom: 5%;
          vertical-align: top;
          width: 20%;
          max-width: 38px;
        }

        p {
          color: @other-grey;
          font-size: 1rem;
          line-height: 1.2;
          margin: 5% 0;
          padding: 0 20px;
          text-align: center;
          white-space: pre-line;
        }
        .uploaded {
          .el-image {
            width: 100%;
            height: 100%;
          }

          .el-button {
            position: absolute;
            width: 60px;
            height: auto;
            bottom: 20px;
            left: 50%;
            margin-left: -30px;
          }
        }
      }
    }
  }
</style>